module.exports = __webpack_public_path__ + "media/images/Shopping-cart-outline-4e1796c2.svg";